import { loadAcalogAPI } from "../acalogAPI";

export function processProgramReqs(module, mapContainer) {
  let programReqTitle = mapContainer.find('h2.acalog-program-core-name:contains("Program Requirements")').first();

  if (!programReqTitle.length) {
    return;
  }

  let descriptionContainer = programReqTitle.next(".acalog-program-core-description");

  if (!descriptionContainer.length) {
    return;
  }

  let programReqDataContainer = module.find(".js-programReqsData");
  programReqDataContainer.html(descriptionContainer.html());
}

function fetchCourseDataAndInject() {
  const cpProgramReqsUrl = '/cp-program-requirements';
  const cpId    = window._cpProgramId;
  const cpTitle = window._cpProgramTitle;
  // Hidden due to task request
  // $(document).on("click", ".js-programReqs a.acalog-permalink-link", function (e) {
  //   const $link = $(this);
  //   const href = $link.attr('href');
  //
  //   const encodedHref  = encodeURIComponent(href);
  //   const encodedId    = encodeURIComponent(cpId);
  //   const encodedTitle = encodeURIComponent(cpTitle);
  //
  //   const goToUrl = window.location.origin + cpProgramReqsUrl + '?cp_url=' + encodedHref + '&cp_id=' + encodedId + '&cp_title=' + encodedTitle;
  //
  //   e.preventDefault();
  //
  //   if (!cpId || !cpTitle) return;
  //
  //   window.location.href = goToUrl;
  // });

  // Handle close button clicks using event delegation
  // $(document).on("click", ".acalog-close", function (e) {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   $(this)
  //     .closest(".acalog-permalink-container").hide();
  // });
}

loadAcalogAPI(fetchCourseDataAndInject, true);